import { CircularProgress, Dialog, DialogContent } from '@mui/material'
import React from 'react'

const LoadingScreen = () => {
  return (
    <Dialog open={true}>
        <DialogContent sx={{background: 'transparent !important'}}>
            <CircularProgress size={"4rem"}/>
        </DialogContent>
    </Dialog>
  )
}

export default LoadingScreen